<template>
  <div id="nav"></div>
  <router-view/>
</template>
